import {
  ComponentStyleConfig,
  anatomy,
  createMultiStyleConfigHelpers,
} from '@cloudbeds/payment-sdk';

const { definePartsStyle } = createMultiStyleConfigHelpers(anatomy.inputAnatomy.keys);

const baseStyle = definePartsStyle({
  field: {
    padding: 0,
    fontSize: 'md',
    fontWeight: 400,
    lineHeight: '2xl',
    color: 'black.500',
    fontFamily: '"Poppins", sans-serif',
    fontSmoothing: 'antialiased',
    marginTop: 0,
    _placeholder: {
      color: 'neutral.400',
    },
    _focus: {
      outline: 'none',
      boxShadow: 'none',
    },
  },
  element: {
    width: '30px',
    paddingRight: 0,
    paddingLeft: 0,
    marginTop: '3px',
  },
});

const elementLeftVariant = definePartsStyle({
  field: {
    paddingLeft: '40px',
  },
  element: {
    marginLeft: 0,
  },
});

const elementRightVariant = definePartsStyle({
  field: {
    paddingRight: '40px',
  },
  element: {
    marginRight: '0px',
  },
});

export const Input: ComponentStyleConfig = {
  baseStyle,
  variants: {
    'element-left': elementLeftVariant,
    'element-right': elementRightVariant,
  },
  defaultProps: {
    variant: 'unstyled',
  },
};
